import service from "@/helpers/py-service";
const state = {
  loading: false,
  downloading: false,
  meta: {},
  list: [],
  sla_statics: {},
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_SLA_STATICS(state, payload) {
    state.sla_statics = payload;
  },

  // ADD_LIST(state, payload) {
  //   state.list.push(payload);
  // },

  UPDATE_LIST(state, payload) {
    const item = state.list.find((item) => item.id === payload.id);
    Object.assign(item, payload);
  },

  DELETE_LIST(state, payload) {
    state.list.splice(state.list.map((o) => o.id).indexOf(payload.id), 1);
  },
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    service
      .get("ticket-management/tickets", params)
      .then((data) => {
        if (data.body?.length) {
          store.commit("SET_LIST", data.body);
        } else {
          store.commit("SET_META", data.body);
          store.commit("SET_LIST", data.body.data);
        }
        return data.body.data;
      })
      .finally(() => (store.state.loading = false));
  },

  add: (store, { payload, filter }) => {
    return service.post("ticket-management/tickets", payload).then(() => {
      // store.commit("ADD_LIST", data.body);
      store.dispatch("list", filter);
    });
  },

  update: (store, payload) => {
    return service
      .put(`ticket-management/tickets/${payload.id}`, payload)
      .then((data) => {
        store.commit("UPDATE_LIST", data.body);
      });
  },

  history: (store, params) => {
    return service
      .get(`ticket-management/tickets/${params.id}/status-history`)
      .then((data) => {
        return data.body;
      });
  },

  sla_statics: (store, params) => {
    return service.get(`ticket-management/sla-statics`, params).then((data) => {
      store.commit("SET_SLA_STATICS", data.body);
      return data.body;
    });
  },

  export: (store, params) => {
    store.state.downloading = true;
    return service
      .get(`ticket-management/tickets/download`, params)
      .then((data) => {
        // const url = window.URL.createObjectURL(new Blob([data.body]));
        //  window.open(data.body.file_url, "_blank");
        return data.body;
      })
      .finally(() => {
        store.state.downloading = false;
      });
  },
  destroy: (store, params) => {
    return service
      .destroy(`ticket-management/tickets/${params.id}`)
      .then(() => {
        store.commit("DELETE_LIST", params);
      });
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
  getSlaStatics() {
    return state.sla_statics;
  },
  getDownloading(state) {
    return state.downloading;
  },
};

const ticketManagement = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default ticketManagement;
